import { render, staticRenderFns } from "./Formula.vue?vue&type=template&id=c4d4e466&scoped=true"
import script from "./Formula.vue?vue&type=script&lang=js"
export * from "./Formula.vue?vue&type=script&lang=js"
import style0 from "./Formula.vue?vue&type=style&index=0&id=c4d4e466&prod&lang=scss&scoped=true"
import style1 from "./Formula.vue?vue&type=style&index=1&id=c4d4e466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d4e466",
  null
  
)

export default component.exports